import { useTranslation } from 'react-i18next';
import { boolean, object } from 'yup';
import { PaymentMethods } from '@models/PaymentMethod';
import { FormValues } from './type';

export const useInitialValues = () => {
  const initialValues: FormValues = {
    agreeToTermsAndConditions: false,
    paymentMethod: PaymentMethods.AbaPay,
  };
  return initialValues;
}

export const useValidationSchema = () => {
  const { t } = useTranslation();

  return object({
    agreeToTermsAndConditions: boolean().test(
      'required',
      t('validation:required'),
      (checked) => checked === true,
    ),
  });
}
